export const BusinessPage = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg
    width="80"
    height="86"
    viewBox="0 0 80 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Utilities / Illustrations / Bussiness page">
      <path
        id="Path"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7772 67.7306H2.51072L0.714355 65.8691V30.5284L2.51072 28.6669H24.2211L25.5731 30.5284V65.8691L23.7772 67.7306Z"
        fill="#CEDDFF"
      />
      <g id="logo">
        <path
          id="Path_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8783 46.4231H4.40942L2.93384 45.7038V32.0495L4.40942 31.3303H22.2429L23.3535 32.0495V45.7038L21.8783 46.4231Z"
          fill="#3A77FF"
        />
        <mask
          id="mask0_8608_19835"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="2"
          y="31"
          width="22"
          height="16"
        >
          <path
            id="Path_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.8783 46.4231H4.40942L2.93384 45.7038V32.0495L4.40942 31.3303H22.2429L23.3535 32.0495V45.7038L21.8783 46.4231Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_8608_19835)">
          <path
            id="Path 3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.7877 11.5018L-14.8225 63.2918L-4.35933 5.58398L31.7877 11.5018Z"
            fill="#1D3C81"
          />
        </g>
      </g>
      <g id="featured">
        <path
          id="Path_4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.936203 20.1047V2.16075L2.30964 0.478882L77.6903 0.478882L79.0637 2.16075L79.0637 20.1047L77.6903 21.3425L2.30964 21.3425L0.936203 20.1047Z"
          fill="#FFD6C9"
        />
        <mask
          id="mask1_8608_19835"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="22"
        >
          <path
            id="Path_5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.936203 20.1047V2.16075L2.30964 0.478882L77.6903 0.478882L79.0637 2.16075L79.0637 20.1047L77.6903 21.3425L2.30964 21.3425L0.936203 20.1047Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_8608_19835)">
          <path
            id="Path 3_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.0025 -6.69881L-8.60767 45.0912L1.85551 -12.6166L38.0025 -6.69881Z"
            fill="#FF5636"
          />
        </g>
      </g>
      <g id="grey ad copy">
        <g id="grey ad">
          <path
            id="Path_6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.776 38.3934V29.5947L33.5919 28.7491L78.3695 28.7491L79.1853 29.5947L79.1853 38.3934L78.3695 39.2389L33.5919 39.2389L32.776 38.3934Z"
            fill="#F2F4F5"
          />
          <mask
            id="mask2_8608_19835"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="28"
            width="48"
            height="12"
          >
            <path
              id="Path_7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.776 38.3934V29.5947L33.5919 28.7491L78.3695 28.7491L79.1853 29.5947L79.1853 38.3934L78.3695 39.2389L33.5919 39.2389L32.776 38.3934Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_8608_19835)">
            <g id="Group">
              <rect
                id="Rectangle"
                x="35.8901"
                y="31.9451"
                width="19.287"
                height="1.31123"
                rx="0.655615"
                fill="#D8DFE0"
              />
              <rect
                id="Rectangle Copy"
                x="35.8901"
                y="34.5677"
                width="8.03623"
                height="1.31123"
                rx="0.655616"
                fill="#D8DFE0"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="grey ad copy 2">
        <g id="grey ad_2">
          <path
            id="Path_8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.776 52.598V43.7993L33.5919 42.9537H78.3695L79.1853 43.7993L79.1853 52.598L78.3695 53.4435L33.5919 53.4435L32.776 52.598Z"
            fill="#F2F4F5"
          />
          <mask
            id="mask3_8608_19835"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="42"
            width="48"
            height="12"
          >
            <path
              id="Path_9"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.776 52.598V43.7993L33.5919 42.9537H78.3695L79.1853 43.7993L79.1853 52.598L78.3695 53.4435L33.5919 53.4435L32.776 52.598Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_8608_19835)">
            <g id="Group_2">
              <rect
                id="Rectangle_2"
                x="35.8901"
                y="46.1497"
                width="19.287"
                height="1.31123"
                rx="0.655616"
                fill="#D8DFE0"
              />
              <rect
                id="Rectangle Copy_2"
                x="35.8901"
                y="48.7722"
                width="8.03623"
                height="1.31124"
                rx="0.655619"
                fill="#D8DFE0"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="grey ad copy 3">
        <g id="grey ad_3">
          <path
            id="Path_10"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.776 67.2471V58.4484L33.5919 57.6028H78.3695L79.1853 58.4484L79.1853 67.2471L78.3695 68.0926L33.5919 68.0926L32.776 67.2471Z"
            fill="#F2F4F5"
          />
          <mask
            id="mask4_8608_19835"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="32"
            y="57"
            width="48"
            height="12"
          >
            <path
              id="Path_11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.776 67.2471V58.4484L33.5919 57.6028H78.3695L79.1853 58.4484L79.1853 67.2471L78.3695 68.0926L33.5919 68.0926L32.776 67.2471Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_8608_19835)">
            <g id="Group_3">
              <rect
                id="Rectangle_3"
                x="35.8901"
                y="60.7988"
                width="19.287"
                height="1.31122"
                rx="0.655612"
                fill="#D8DFE0"
              />
              <rect
                id="Rectangle Copy_3"
                x="35.8901"
                y="63.4214"
                width="8.03623"
                height="1.31123"
                rx="0.655616"
                fill="#D8DFE0"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="Path_12"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.0459 85.4869H2.51072L0.714355 84.9792V75.3408L2.51072 74.8331H77.4898L78.8419 75.3408V84.9792L77.0459 85.4869Z"
        fill="#F2F4F5"
      />
    </g>
  </svg>
);
